export const analytics = {
  title: "Análises",
  subtitle: "Receitas e ocupação das suas propriedades no período que escolher.",
  tabs: {
    performance: "Desempenho",
    channels: "Canais",
  },
  allAccommodations: "Todas as acomodações",
  compare: {
    prevPeriod: "Período anterior",
    prevYear: "Ano anterior",
    titlePrevPeriod: "Comparação: período anterior",
    titlePrevYear: "Comparação: ano anterior",
    inlinePrevPeriod: "período anterior",
    inlinePrevYear: "ano anterior",
  },
  summary: {
    currentPeriod: "Período atual",
    paymentFilter: "Filtro de pagamento",
  },
  presets: {
    today: "Hoje",
    yesterday: "Ontem",
    d7: "7 dias",
    d30: "30 dias",
    m3: "3 meses",
    m6: "6 meses",
    year: "1 ano",
  },
  payment: {
    all: "Todos os pagamentos",
    pending: "Pendente",
    paid: "Pago",
    rejected: "Recusado",
    refunded: "Reembolsado",
    partial: "Pagamento parcial",
  },
  kpi: {
    totalRevenue: "Receita do período",
    arrivalRevenue: "Valor total das chegadas",
    revpar: "RevPAR",
    occupancyRate: "Taxa de ocupação",
    adr: "ADR",
    avgStay: "Estadia média",
    bookingWindow: "Antecedência de reserva",
  },
  units: {
    days: " dias",
  },
  chart: {
    thisPeriod: "Este período",
    subtitle: "{current} · comparado com {compared} · {payment}",
  },
  channels: {
    directBookings: "Reservas diretas",
    otaBookings: "Reservas via OTA",
    bookingDetails: "Detalhes das reservas",
    byChannel: "Por canal",
    tableChannel: "Canal",
    tableRevenue: "Receita",
    direct: "Direto",
    ota: "OTA",
    noData: "Sem dados para o período selecionado",
  },
  a11y: {
    chartOf: "Gráfico de {label}",
    directVsOta: "Gráfico de reservas diretas vs OTA",
  },
};